<template>
  <div>
    <transition name="modal">
      <div class="modal-mask" @click="$emit('closePopup');">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" @click="$emit('closePopup');">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <iframe frameborder="0" allowfullscreen :src="wechatUrl" height="400px"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: [ 'wechatUrl' ],
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-header {
  border-bottom: unset;
  padding: 10px;
}

.modal-body {
  display: flex;
  justify-content: center;
}
</style>